import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import FlagModal from '../../../../../components/Modal/FlagModal';
import Card from '../../../../../components/Card';

const propTypes = {
  user: PropTypes.object,
  updateUser: PropTypes.func,
};

class Flags extends Component {
  state = {
    showModal: false,
    flag: {}
  }

  render() {
    const { showModal, flag } = this.state;
    const { user, updateUser } = this.props;

    return (
      <Fragment>
        <Card>
          <Card.Header>
            Flags
            <button className="btn btn-primary float-right" onClick={() => this.setState({ showModal : true })}>
              Add Flag
            </button>
          </Card.Header>
          <Card.Body>
            {(user.flags == null) || (user.flags.length == 0) ? (
              <p>This user does not have any flags</p>
            ) : (
              <table className="table">
                <thead>
                  <tr>
                    <th>Reason</th>
                    <th>Note</th>
                    <th>Date Created</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {user.flags.map((flag) => (
                    <tr key={flag.reason}>
                      <td className="whiteSpaceWrap">{flag.reason}</td>
                      <td className="whiteSpaceWrap">{flag.note}</td>
                      <td>{moment(flag.createdAt).format('MM/DD/YYYY')}</td>
                      <td>{flag.active ? 'Active' : 'Resolved'}</td>
                      <td>
                        <button
                          className="btn btn-link float-right"
                          onClick={() => this.setState({ showModal : true, flag: flag })}
                        >
                          Update
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card.Body>
        </Card>
        <FlagModal
          show={showModal}
          user={user}
          onHide={() => this.setState({ showModal: false, flag: {} })}
          updateUserFlags={(flags) => updateUser({ ...user, flags})}
          flag={flag}
        />
      </Fragment>
    );
  }
}

Flags.propTypes = propTypes;

export default Flags;
